<template>
  <i-modal v-model="modal" @on-visible-change="onVisibleChange" title="外観・間取り" width="1000" footer-hide>
    <div>
      <template v-if="images.length === 0">
        <div class="no-image">表示する画像がありません。</div>
      </template>
      <template v-else>
        <i-carousel>
          <i-carousel-item v-for="(value, idx) in images" :key="idx">
            <div class="carousel-wrap">
              <img :src="value" />
            </div>
          </i-carousel-item>
        </i-carousel>
      </template>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Carousel, CarouselItem } from 'view-design'
export default {
  components: {
    'i-modal': Modal,
    'i-carousel': Carousel,
    'i-carousel-item': CarouselItem,
  },
  data() {
    return {}
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalImagePreview/getModal']
      },
      set(val) {
        this.$store.commit('ModalImagePreview/setModal', val)
      },
    },
    images: {
      get() {
        return this.$store.getters['ModalImagePreview/getImages']
      },
      set(val) {
        this.$store.commit('ModalImagePreview/setImages', val)
      },
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    async onVisibleChange(isOpen) {
      if (isOpen) {
        // 表示処理
      } else {
        // 非表示処理
        setTimeout(this.resetParam, 300)
      }
    },
    // パラメータをリセットする
    resetParam() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      this.$store.dispatch('ModalImagePreview/reset')
    },
  },
}
</script>

<style lang="scss" scoped>
.carousel-wrap {
  width: 100%;
  height: 480px;
  padding: 24px;
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.no-image {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
